/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SharedExpense } from './SharedExpense';
import {
    SharedExpenseFromJSON,
    SharedExpenseFromJSONTyped,
    SharedExpenseToJSON,
    SharedExpenseToJSONTyped,
} from './SharedExpense';

/**
 *
 * @export
 * @interface SharedSettlement
 */
export interface SharedSettlement {
    /**
     *
     * @type {boolean}
     * @memberof SharedSettlement
     */
    depositPaid?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof SharedSettlement
     */
    rentalPaid?: boolean;
    /**
     *
     * @type {string}
     * @memberof SharedSettlement
     */
    ticketSales?: string;
    /**
     *
     * @type {Array<SharedExpense>}
     * @memberof SharedSettlement
     */
    approvedExpenses?: Array<SharedExpense>;
    /**
     *
     * @type {boolean}
     * @memberof SharedSettlement
     */
    settled?: boolean;
    /**
     *
     * @type {Date}
     * @memberof SharedSettlement
     */
    settlementDate?: Date | null;
}

/**
 * Check if a given object implements the SharedSettlement interface.
 */
export function instanceOfSharedSettlement(value: object): value is SharedSettlement {
    return true;
}

export function SharedSettlementFromJSON(json: any): SharedSettlement {
    return SharedSettlementFromJSONTyped(json, false);
}

export function SharedSettlementFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedSettlement {
    if (json == null) {
        return json;
    }
    return {

        'depositPaid': json['deposit_paid'] == null ? undefined : json['deposit_paid'],
        'rentalPaid': json['rental_paid'] == null ? undefined : json['rental_paid'],
        'ticketSales': json['ticket_sales'] == null ? undefined : json['ticket_sales'],
        'approvedExpenses': json['approved_expenses'] == null ? undefined : ((json['approved_expenses'] as Array<any>).map(SharedExpenseFromJSON)),
        'settled': json['settled'] == null ? undefined : json['settled'],
        'settlementDate': json['settlement_date'] == null ? undefined : (new Date(json['settlement_date'])),
    };
}

  export function SharedSettlementToJSON(json: any): SharedSettlement {
      return SharedSettlementToJSONTyped(json, false);
  }

  export function SharedSettlementToJSONTyped(value?: SharedSettlement | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'deposit_paid': value['depositPaid'],
        'rental_paid': value['rentalPaid'],
        'ticket_sales': value['ticketSales'],
        'approved_expenses': value['approvedExpenses'] == null ? undefined : ((value['approvedExpenses'] as Array<any>).map(SharedExpenseToJSON)),
        'settled': value['settled'],
        'settlement_date': value['settlementDate'] == null ? undefined : ((value['settlementDate'] as any).toISOString().substring(0,10)),
    };
}
